var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"py-0"},[_c('InspResultReportForm',{attrs:{"inspIndexNo":_vm.inspIndexNo}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }